import type { IStrapiImage } from './strapiImage';

export enum EPaymentsType {
  deposit = 'deposit',
  withdrawal = 'withdrawal',
}

export enum EPaymentSystemType {
  EWallet = 'eWallet',
  Neosurf = 'neosurf',
  OnlineBanking = 'onlineBanking',
  CreditDebitCard = 'creditDebitCard',
  PrepaymentCard = 'prepaymentCard',
}

export interface IPaymentData {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  publishedAt?: Date;
  name: string;
  position: number;
  logo: IStrapiImage;
  type: EPaymentsType;
  paymentType: EPaymentSystemType;
  fee?: string;
  paymentProcessingTime?: string;
  limitsMin?: string;
  limitsMax?: string;
  includedCountries?: string;
  excludedCountries?: string;
  includedGroups?: string;
  excludedGroups?: string;
  paymentMethodLogoId?: string;
  shouldOpenByCryptoModal?: boolean;
  showForEstonia?: boolean;
}

export interface IPaymentStrapiResponse {
  data: IPaymentData[];
}

export interface IPaymentSystemImages {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  publishedAt?: Date;
  paymentProviderLogo?: IStrapiImage;
  methodLogoId: string;
  recomendedForCurrencies?: string;
  presetAmounts: {
    availableAmounts?: string;
    preselectedAmount?: string;
    includedGroups?: string;
    excludedGroups?: string;
  }[];
  paymentBonusLabel: {
    title?: string;
    includedGroups?: string;
    excludedGroups?: string;
  }[];
}

export interface IPaymentSystemImagesStrapiResponse {
  data: IPaymentSystemImages[];
}

export interface IPaymentSystemPosition {
  paymentSystemId: string;
  position: number;
}

export interface IPaymentSystemSortingData {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  publishedAt?: Date;
  groupId: string;
  isForWithdraw?: boolean | null;
  paymentSystems: IPaymentSystemPosition[];
}

export interface IPaymentSystemSortingStrapiResponse {
  data: IPaymentSystemSortingData[];
}
